import { createReducer, on } from "@ngrx/store";
import { FeatureStateInterface } from "./featureState.interface";
import { batchToggleFeatureSuccess, disableFeatureSuccess, enableFeatureSuccess, getAllAvailableFeatures, getAllFeatures, invokeDisableFeature, invokeEnableFeature } from "./features.actions";

export const initialState: Readonly<FeatureStateInterface> = {
    features: null,
    availableFeatures: null,
    success: null
};

export const FeaturesReducer = createReducer(
    initialState,
    on(getAllFeatures, (state, { features }) => ({ ...state, features })),
    on(getAllAvailableFeatures, (state, { availableFeatures }) => ({ ...state, availableFeatures })),
    on(enableFeatureSuccess, (state, { success }) => ({ ...state, success })),
    on(disableFeatureSuccess, (state, { success }) => ({ ...state, success })),
    on(batchToggleFeatureSuccess, (state, { success }) => ({ ...state, success })),
);
